import React from "react";
import DSDModuleSubtopic from "../DSDModuleSubtopic";

const VerilogHDLModule2 = () => (
  <DSDModuleSubtopic
    title="Verilog HDL"
    videos={[
      "https://www.youtube.com/embed/yhV92Zf_Ziw",
      "https://www.youtube.com/embed/LBXU50tS54o",
      "https://www.youtube.com/embed/21luFDi1kS8",
      "https://www.youtube.com/embed/SNPZ8sF3FXs",
      "https://www.youtube.com/embed/WQEipKV81KQ",
      "https://www.youtube.com/embed/KeAoG1R7vUg"
    ]}
    takeaways={[
      { text: "The understanding of Verilog is crucial to write codes in other modules and application based questions." },
      { text: "Mainly learn how to find errors in the code and learn how to convert code from one modelling to other modelling." },
      { text: "Learn how to write test bench sometimes test bench alone can be asked." }
    ]}
    questions={[
      {
        text: "Develop 3 bit input (x, y and z) XOR Gate in Verilog HDL using AND, OR and NOT Gates primitives. Write the truth table, derive the expression and write the stimulus (Test Bench) mode that exercises all combinations of x, y and z."
      },
      {
        text: "Find the syntax errors in the following declarations (note that names for primitive gates are optional)",
        image:"/dsd_2.png"
      },
      {
        text: "Draw the truth table and logic diagram of the digital circuit specified by the following Verilog description:",
        image:"/dsd_3.png"
      },
      {
        text: "Draw the logic diagram of the digital circuit specified by the following Verilog description:",
        image:"/dsd_4.png"
      },
      {
        text: "Identify the errors in the following code and find out the logical expression. Also draw the truth table and logical diagram from the logical expression.",
        image:"/dsd_5.png"
      },
      {
        text: "Identify the errors in the following code and write the correct Verilog HDL Code with line by line comments, Identify the circuit developed by the given Also write the code for test-bench.",
        image:"/dsd_6.png"
      },
      {
        text: "Give step by step comments for each line of the code and Elaborate the functionality of the Verilog code. Draw the output truth table, waveform and circuit for the given Verilog code. Realize the circuit only using two input NAND gates.",
        image:"/dsd_7.png"
      },
      {
        text: "Implement the given Boolean Function using gate level Verilog HDL. Also write the test bench to verify the design F=(AB)(C'D)'+(A'+B+C)'+(A'B'D)"
      }
    ]}
    exampleVideos={[]}
  />
);

export default VerilogHDLModule2;
